// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICarrierConfigResponseAggregatorDto
 */
export interface ICarrierConfigResponseAggregatorDto {
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigResponseAggregatorDto
     */
    carrier_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigResponseAggregatorDto
     */
    carrier_external_id?: string;
    /**
     * 
     * @type {number}
     * @memberof ICarrierConfigResponseAggregatorDto
     */
    carrier_config_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigResponseAggregatorDto
     */
    submitter_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigResponseAggregatorDto
     */
    organization?: string;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigResponseAggregatorDto
     */
    purpose_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigResponseAggregatorDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ICarrierConfigResponseAggregatorDto
     */
    observable_org_path?: string;
}

/**
 * Check if a given object implements the ICarrierConfigResponseAggregatorDto interface.
 */
export function instanceOfICarrierConfigResponseAggregatorDto(value: object): value is ICarrierConfigResponseAggregatorDto {
    return true;
}

export function ICarrierConfigResponseAggregatorDtoFromJSON(json: any): ICarrierConfigResponseAggregatorDto {
    return ICarrierConfigResponseAggregatorDtoFromJSONTyped(json, false);
}

export function ICarrierConfigResponseAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICarrierConfigResponseAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'carrier_name': json['carrier_name'] == null ? undefined : json['carrier_name'],
        'carrier_external_id': json['carrier_external_id'] == null ? undefined : json['carrier_external_id'],
        'carrier_config_id': json['carrier_config_id'] == null ? undefined : json['carrier_config_id'],
        'submitter_id': json['submitter_id'] == null ? undefined : json['submitter_id'],
        'organization': json['organization'] == null ? undefined : json['organization'],
        'purpose_type': json['purpose_type'] == null ? undefined : json['purpose_type'],
        'description': json['description'] == null ? undefined : json['description'],
        'observable_org_path': json['observable_org_path'] == null ? undefined : json['observable_org_path'],
    };
}

export function ICarrierConfigResponseAggregatorDtoToJSON(json: any): ICarrierConfigResponseAggregatorDto {
    return ICarrierConfigResponseAggregatorDtoToJSONTyped(json, false);
}

export function ICarrierConfigResponseAggregatorDtoToJSONTyped(value?: ICarrierConfigResponseAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carrier_name': value['carrier_name'],
        'carrier_external_id': value['carrier_external_id'],
        'carrier_config_id': value['carrier_config_id'],
        'submitter_id': value['submitter_id'],
        'organization': value['organization'],
        'purpose_type': value['purpose_type'],
        'description': value['description'],
        'observable_org_path': value['observable_org_path'],
    };
}

